import React from "react"

export default function NotFoundPage() {
    return (
        <div className="notFoundPage">
            <div className="notFoundText">Page was not found or doesn't exist</div>
        </div>
    )
}